import { render, staticRenderFns } from "./DataPersons.vue?vue&type=template&id=269aa0a9"
import script from "./DataPersons.vue?vue&type=script&lang=js"
export * from "./DataPersons.vue?vue&type=script&lang=js"
import style0 from "./DataPersons.vue?vue&type=style&index=0&id=269aa0a9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports